declare const I18n;

import React from "react";

type ProgressBarProps = {
  progress: number; 
};

const AchievementProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <div className="achievement-progress-bar">
      <div
        className="achievement-progress-bar__fill"
        style={{ width: `${Math.min(Math.max(progress, 0), 100)}%` }}
      />
    </div>
  );
};


export default AchievementProgressBar;
